import {getFloorById, getPreferences, useAppSelector} from '@lib/store';
import {useHereAndNow} from '@pages';
import {useTranslation} from 'react-i18next';

export const FloorListHeader = ({type}: {type: 'available' | 'suggestion'}) => {
  const {t} = useTranslation();

  const {selectedFloorId} = useHereAndNow();

  const floor = useAppSelector((s) => getFloorById(s, selectedFloorId || ''));
  const preferences = useAppSelector(getPreferences);

  return (
    floor && (
      <div className="px-5 py-2 my-2 flex justify-between items-center sticky top-0 bg-white z-10">
        <h3>{type === 'suggestion' ? t('hereAndNow:SuggestionsOnOtherFloors') : `${t('Floor')} ${floor.number}`}</h3>
        {type === 'available' && preferences.workspaceLocation?.floorId === floor.id && (
          <p className="text-mapiq-black-800*">{t('YourPreference')}</p>
        )}
      </div>
    )
  );
};
